<template>
    <div class="vue-iframe-modal-button">
        <template v-if="needsModal">
            <a @click.prevent="callModal" oncontextmenu="return false;" href="#" class="" :class="buttonClasses">Afspraak maken</a>
        </template>

        <template v-else>
            <a :href="iframeSrc" :class="buttonClasses" oncontextmenu="return false;" target="_blank">Afspraak maken</a>
        </template>
    </div>
</template>

<script>
export default {
    name: "IframeModalButton",

    props: ['iframeSrc', 'buttonClasses', 'modalBus'],

    computed: {
        needsModal() {
            return ! this.iframeSrc.includes('https://johngreup.nl/afspraak');
        }
    },

    methods: {
        callModal() {
            this.modalBus.$emit('show-iframe-modal', {
                iframeSrc: this.iframeSrc
            });
        }
    }
}
</script>